import { DefaultDialog } from "@graffer-inc/console-design-kit";
import { ProductDataRemovalTask } from "../../../../../application/domain/product-data-removal-task";

type ProductDataRemovalTaskCancelModalProps = {
  task: ProductDataRemovalTask;
  onProceed: (task: ProductDataRemovalTask) => void;
  onCancel: () => void;
};

export const ProductDataRemovalTaskCancelModal = ({
  task,
  onProceed,
  onCancel,
}: ProductDataRemovalTaskCancelModalProps) => {
  return (
    <DefaultDialog
      title="製品データ削除タスクのキャンセル"
      proceedText="キャンセルする"
      cancelText="やめる"
      onProceed={() => onProceed(task)}
      onCancel={onCancel}
      contents={
        <div>
          <p>キャンセルしてよろしいですか？</p>
        </div>
      }
    />
  );
};
